import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../UI/Modal/Modal'
import cl from '../../UI/Modal/Modal.module.css'
import Car from "../../../assets/Icon/Car"; 
import fnc from './Finances.module.css'
import { AppContext } from '../../../providers/appProvider';
import SalerPriceForm from './Update/SalerPriceForm/SalerPriceForm';

const SalerPriceModal = ({ carService, defaultCar, setDefaultCar, onSave }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [car, setCar] = useState(defaultCar);
    const {appState, app} = useContext(AppContext);
    const prices = carService.calculatePrice(defaultCar); 


    useEffect(() => {
        setCar(defaultCar)

        if(defaultCar?.dealer?.id != null && defaultCar.dealer.id > 0 ){
            setCar({
                ...defaultCar, 
                dealer_id: defaultCar.dealer.id,
            }) 
        }

    }, [defaultCar]);

  
    const onUpdateClick = (event) => {
          carService.updateSalerPrice(car)
          setIsModalOpen(false)
          onSave()
    };    
 
   

    return (
        <div> 
  
            <div onClick={() => setIsModalOpen(true)} className={fnc.financeBox + ' ' + fnc.violetFin}  >
                <div className={fnc.financeDesc + ' nonetable ' }> სეილერი</div>
                <div className={fnc.financeValue}> {(defaultCar.total_saler_price !== 0 ? defaultCar.total_saler_price : ' ')} </div>
            </div>
  
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead  +' ' +fnc.violetFin } >
                    <h3>
                        <span className={ fnc.iconHead +' '+fnc.violetFin } > <Car/></span>
                        
                        <div style={{ display: 'flex', flexDirection: 'column' }}>  
                            <div style={{ lineHeight: 1, fontSize: 14, fontWeight: 600, marginTop: 3 }}> {car.id}{defaultCar.lot !== undefined ? '/' + defaultCar.lot : '' }</div>
                        </div>
                        
                    </h3>
                </div>
                <div>
  
                    <SalerPriceForm newCar={car} setNewCar={setDefaultCar} isAdd={true} prices={prices} ></SalerPriceForm>
 

                    {app.hasPermission("SALER_PRICE_EDIT") &&
                    
                        <div className={ fnc.flexend }>
                            <button type="submit" onClick={onUpdateClick} className={fnc.btnPrimary } >შენახვა</button>
                        </div>

                    }
                  
 

                </div>




 
            </Modal>
        </div>
    );
};

export default SalerPriceModal;